import React from 'react';

import { styled, TextInput, TextInputProps } from '@meterup/atto';
import { FieldRenderProps } from 'react-final-form';

const Error = styled('span', {
  fontSize: '$12',
  paddingLeft: '$4',
  color: '$red800',
});

// Mixed interface between React Final Form and our pure TextInputForm
export interface TextInputFieldProps extends FieldRenderProps<string>, TextInputProps {}

function TextInputField({
  // React Final Form
  input,
  meta,
  placeholder,
  id,
  error,
  // Frontend components
  size,
  icon,
  prefix,
  suffix,
  autocomplete,
  disabled,
  ariaLabel,
  inputProps,
}: TextInputFieldProps) {
  const err = error || (meta.touched && (meta.error || meta.submitError)) || undefined;

  const inputType = input.type as TextInputProps['type'];
  const internalOnChange = (value: string) =>
    input.onChange({
      target: {
        value,
      },
    });
  return (
    <div>
      <TextInput
        id={id}
        name={input.name}
        onChange={internalOnChange}
        // @ts-ignore: 2322
        onBlur={input.onBlur}
        // @ts-ignore: 2322
        onFocus={input.onFocus}
        value={input.value}
        type={inputType}
        placeholder={placeholder}
        autoComplete={autocomplete}
        size={size}
        icon={icon}
        prefix={prefix}
        suffix={suffix}
        disabled={disabled}
        invalid={!!err}
        aria-label={ariaLabel}
        inputProps={inputProps}
      />
      {!!err && <Error>{err}</Error>}
    </div>
  );
}

export default TextInputField;
